import React from 'react';

import BottomSheet from 'components/BottomSheet';
import useStoreTranslation from 'hooks/useStoreTranslation';

import { ConfirmButton, Container, Title, Text, ButtonContainer, Header, CloseButton, IconClose } from './styles';

interface Props {
  show: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading: boolean;
}
const FlightsExchangeConfirm = ({ show, onClose, onConfirm, isLoading }: Props) => {
  const { t } = useStoreTranslation();
  return (
    <BottomSheet
      noHeader
      modal
      show={show}
      onClose={onClose}
      style={{ maxHeight: 330, backgroundColor: '#F9F9F9' }}
      zIndex={11}
    >
      <Header>
        <Header.Title>{t('travelDetails.exchangeWarning.title')}</Header.Title>
        <Header.Close>
          <CloseButton onClick={onClose}>
            <IconClose />
          </CloseButton>
        </Header.Close>
      </Header>
      <Container>
        <Title>{t('travelDetails.exchangeWarning.subtitle')}</Title>
        <Text>{t('travelDetails.exchangeWarning.text')}</Text>
        <Title>{t('travelDetails.exchangeWarning.question')}</Title>
      </Container>
      <ButtonContainer>
        <ConfirmButton
          type="button"
          value={t('travelDetails.exchangeWarning.button')}
          onClick={onConfirm}
          loading={isLoading}
          disabled={false}
        />
      </ButtonContainer>
    </BottomSheet>
  );
};

export default FlightsExchangeConfirm;
